import React from 'react';
import {connect} from 'react-redux';

import {hideToast} from '../../actions/Toast';
import Toast from '../../components/Common/Toast';

const ToastContainer = (props) => {
  return (
    <Toast
      toasts={props.toasts}
      hideToast={props.hideToast}
      isMicroFrontend={props.isMicroFrontend}
    />
  );
};

export default connect(
  (state) => ({
    toasts: state.toast.toasts,
    isMicroFrontend: state.app.isMicroFrontend,
  }),
  {hideToast},
)(ToastContainer);
